export const profileMenu = [
  { label: 'signin', link: '/auth/signin' },
  { label: 'signup', link: '/auth/register' },
];
export const profileMenuSignedIn = [
  { label: 'account', link: '/my-account/account' },
  { label: 'logout', link: '/' },
];
